export const signUpUserConfig = {
  singUpEP: '/user/sign-up',
  verifyEP: '/email/verify-by-otp',
};
